import _ from "lodash";

/**
 * Revision bookkeeping shared by the editor save path and the S3 writers.
 *
 * Every save compares the next in-memory revision with the revision carried by the
 * copy on S3. Activities that were imported before the S3 copies were stamped carry
 * no revision at all (only their inventory document does), so a strict comparison
 * blocked their first save forever with "the content on S3 is more recent".
 */
export function getTrackedRevision(activity) {
	return _.isObject(activity) && _.isNumber(activity.revision) && !_.isNaN(activity.revision) ? activity.revision : null;
}

/**
 * A saved copy can only be "more recent" when it tracks a revision at all. No copy
 * (null) and an untracked copy are both accepted; a tracked copy must be exactly the
 * revision the in-memory activity was loaded from.
 */
export function isSavedRevisionCompatible(savedActivity, nextRevision) {
	const saved = getTrackedRevision(savedActivity);
	if (saved === null) {
		return true;
	}
	return _.isNumber(nextRevision) && saved === nextRevision - 1;
}

/**
 * Stamp the first revision on an activity that has none so the S3 copies carry the
 * same value the inventory document receives. Existing revisions are left alone.
 */
export function ensureActivityRevision(activity, now = Date.now()) {
	if (!_.isObject(activity)) {
		return activity;
	}
	if (getTrackedRevision(activity) === null) {
		activity.revision = 1;
	}
	if (!_.isNumber(activity.revisionTs) || _.isNaN(activity.revisionTs)) {
		activity.revisionTs = now;
	}
	return activity;
}
